import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {
	AppLayoutComponent, LoginComponent, LogoutComponent, NewLoginComponent, PasswordConfirmComponent, PasswordResetComponent, SignupComponent, ProfileComponent, TosComponent, GuidelinesComponent, RouteGuard
} from './core';
import { MissingComponent, ErrorResponseComponent } from './errorComponents';
import { VersionsResolver } from '@socrates/socrates-shared';

export const routes: Routes = [
	{
		path: 'missing',
		component: MissingComponent,
	},
	{
		path: 'serverError',
		component: ErrorResponseComponent,
	},
	{
		path: '',
		redirectTo: '/dashboard',
		pathMatch: 'full',
	},
	{
		path: '',
		component: AppLayoutComponent,
		canActivate: [RouteGuard],
		children: [
			{
				path: 'dashboard',
				loadChildren: () => import('./core/dashboard/dashboard.module').then(m => m.DashboardModule)
			},
			{
				path: 'admin',
				loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)
			},
			{
				path: 'pillars',
				loadChildren: () => import('./core/pillars/pillars.module').then(m => m.PillarsModule),
				data: { privilege: 'IdeaManagement.READ' },
			},
			{
				path: 'proposals',
				loadChildren: () => import('./core/proposals/proposals.module').then(m => m.ProposalsModule),
				data: { privilege: 'IdeaManagement.READ' },
			},
			{
				path: 'deliberation',
				loadChildren: () => import('./core/deliberation/deliberation.module').then(m => m.DeliberationModule),
				data: { privilege: 'IdeaManagement.READ' },
			},
			{
				path: 'profile',
				component: ProfileComponent,
			},
		]
	},
	{
		path: 'logout',
		component: LogoutComponent
	},
	{
		path: 'login',
		component: LoginComponent,
		resolve: {
			versions: VersionsResolver
		},
	},
	{
		path: 'newLogin',
		component: NewLoginComponent,
		resolve: {
			versions: VersionsResolver
		},
	},
	{
		path: 'passwordReset',
		component: PasswordResetComponent,
	},
	{
		path: 'passwordConfirm',
		component: PasswordConfirmComponent,
	},
	{
		path: 'signup',
		component: SignupComponent,
	},
	{
		path: 'tos',
		component: TosComponent,
	},
	{
		path: 'community-guidelines',
		component: GuidelinesComponent,
	},
	{
		path: '**',
		redirectTo: '/missing'
	}
];

@NgModule({
	imports: [ RouterModule.forRoot(routes) ],
	exports: [ RouterModule ]
})
export class AppRoutingModule {
}
